import React from 'react';
import { Button } from '../ui/button';

const LABELS = {
  international_investor: 'Inversionista internacional', business_owner: 'Dueño de negocio', other: 'Otro',
  strategic: 'Planificación fiscal', international: 'Internacional', realestate: 'Bienes raíces', business: 'Impuestos empresariales',
  accounting: 'Contabilidad', not_sure: 'Por definir', en: 'Inglés', es: 'Español',
};
const label = (v) => LABELS[v] || v;
const fmt = (d) => (d ? new Date(d).toLocaleString('es-ES', { dateStyle: 'medium', timeStyle: 'short' }) : '');

export const TestimonialsTable = ({ items, onApprove, onDelete }) => (
  <div className="space-y-3" data-testid="admin-testimonials-list">
    {items.length === 0 && <p className="text-gray-500 text-sm">No hay testimonios.</p>}
    {items.map((t) => (
      <div key={t.id} data-testid={`admin-testimonial-${t.id}`} className="bg-white border border-tan/60 rounded-xl p-4">
        <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
          <div className="font-semibold text-cafe-noir">{t.name} <span className="text-moss-green">{'★'.repeat(t.rating)}</span></div>
          <span className={`text-xs px-2 py-1 rounded-full ${t.approved ? 'bg-kombu-green text-white' : 'bg-bone text-cafe-noir'}`}>
            {t.approved ? 'Publicado' : 'Pendiente'}
          </span>
        </div>
        <p className="text-sm text-gray-700 whitespace-pre-wrap mb-2">{t.comment}</p>
        <div className="text-xs text-gray-500 mb-3">{t.email} · {fmt(t.created_at)}</div>
        <div className="flex gap-2">
          {!t.approved && (
            <Button size="sm" data-testid={`admin-approve-${t.id}`} onClick={() => onApprove(t.id)}
              className="bg-kombu-green hover:bg-kombu-green-dark text-white">Aprobar</Button>
          )}
          <Button size="sm" variant="outline" data-testid={`admin-delete-${t.id}`} onClick={() => onDelete(t.id)}
            className="border-red-300 text-red-700 hover:bg-red-50">Eliminar</Button>
        </div>
      </div>
    ))}
  </div>
);

export const ContactsTable = ({ items }) => (
  <div className="space-y-3" data-testid="admin-contacts-list">
    {items.length === 0 && <p className="text-gray-500 text-sm">No hay mensajes.</p>}
    {items.map((c) => (
      <div key={c.id} data-testid={`admin-contact-${c.id}`} className="bg-white border border-tan/60 rounded-xl p-4">
        <div className="flex flex-wrap justify-between gap-2 mb-1">
          <div className="font-semibold text-cafe-noir">{c.name}</div>
          <div className="text-xs text-gray-500">{fmt(c.created_at)}</div>
        </div>
        <div className="text-sm text-gray-600 mb-2 break-all">{c.email}{c.phone ? ` · ${c.phone}` : ''}</div>
        {(c.client_category || c.country || c.service) && (
          <div className="text-xs text-gray-500 mb-2" data-testid={`admin-contact-meta-${c.id}`}>
            {[c.client_category, c.country, c.service, c.preferred_language].filter(Boolean).map(label).join(' · ')}
          </div>
        )}
        <p className="text-sm text-gray-700 whitespace-pre-wrap">{c.message}</p>
      </div>
    ))}
  </div>
);
